import { useEffect, useState } from 'react';
import { formatElapsedTime } from 'utils/date-utils';
import { KioskCardElapsed } from '../styles';

interface ElapsedCounterProps {
  startTimeUtc: string;
}

/** Live `HH:mm:ss` elapsed counter; re-renders once per second from the device clock. */
const ElapsedCounter = ({ startTimeUtc }: ElapsedCounterProps) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return <KioskCardElapsed>{formatElapsedTime(startTimeUtc, now)}</KioskCardElapsed>;
};

export default ElapsedCounter;
